import { html, nothing } from 'lit';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
import { MobxLitElement } from '@adobe/lit-mobx';
import { customElement, property, state } from 'lit/decorators.js';
import '@digital-realty/ix-icon-button/ix-icon-button.js';
import { TWStyles } from '../../tw.js';
import { NotificationsState } from '../../state/NotificationState.js';
import { Notification } from '../../models/notification.js';
import { NotificationsStyle } from '../../styles/notifications-style.js';
import { NotificationGroups } from '../../constants/notifications.js';

@customElement('grouped-item')
export class GroupedItem extends MobxLitElement {
  @property({ type: String, attribute: true }) groupTitle = 'Group 1';

  @property({ type: String, attribute: true }) groupIcon = 'public';

  @property({ type: Array, attribute: true }) childItems?: Notification[] =
    NotificationsState.notifications;

  @state() private isOpen = false;

  onClick = () => {
    this.isOpen = !this.isOpen;
  };

  static get styles() {
    return [TWStyles, NotificationsStyle];
  }

  renderNotificationItems() {
    if (this.isOpen) {
      if (
        this.childItems?.length !== undefined &&
        this.childItems?.length > 0
      ) {
        return html`<div>
          ${this.childItems?.map(
            item => html`<notification-item
              .notification=${item}
              ?disabled=${item.resourceType === NotificationGroups.INCIDENTS}
              data-testclass="notification-item"
            >
            </notification-item>`
          )}
        </div>`;
      }
      return html`<p
        class="dlr-text-caption ml-14 font-bold mr-4"
        data-testid="msg-no-notifications"
      >
        No notifications yet.
      </p>`;
    }

    return html`${nothing}`;
  }

  render() {
    return html`<div class="group-container-row border-b border-outline py-3">
      <div class="flex items-center justify-between">
        <div class="flex items-center align-middle">
          <ix-icon-button
            icon=${this.isOpen ? 'arrow_drop_down' : 'arrow_right'}
            @click="${this.onClick}"
            data-testclass="grouped-item-toggle-expand"
          >
          </ix-icon-button>
          <ix-icon slot="default" class="ix-icon-groups"
            >${unsafeSVG(this.groupIcon)}</ix-icon
          >
          <p class="m-0 group-name font-bold pl-1">${this.groupTitle}</p>
          <p class="m-0 pl-4">
            ${this.childItems?.length.toString().padStart(2, '0')}
          </p>
        </div>
      </div>
      ${this.renderNotificationItems()}
    </div>`;
  }
}
